export const defaultButtonTypes = ['primary', 'primaryMuted', 'neutralMuted'];
